// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-kf-","content":"styles_content__3HPDk","row":"styles_row__3BrgH","footer":"styles_footer__3p8Lh","phraseLength":"styles_phraseLength__3KcwD"};